export enum TipCalculator {
  RESET_CALCULATOR_PAYMENTSET = '@@tipcalculator/RESET_CALCULATOR_PAYMENTSET',
  UPDATE_CALCULATOR_PAYMENTSET_REQUEST = '@@tipcalculator/UPDATE_CALCULATOR_PAYMENTSET_REQUEST',

  GET_POS_REQUEST = '@@tipcalculator/GET_POS_REQUEST',
  GET_POS_SUCCESS = '@@tipcalculator/GET_POS_SUCCESS',
  GET_POS_FAIL = '@@tipcalculator/GET_POS_FAIL',

  GET_CALCULATED_TIPS_REQUEST = '@@tipcalculator/GET_CALCULATED_TIPS_REQUEST',
  GET_CALCULATED_TIPS_SUCCESS = '@@tipcalculator/GET_CALCULATED_TIPS_SUCCESS',
  GET_CALCULATED_TIPS_FAIL = '@@tipcalculator/GET_CALCULATED_TIPS_FAIL',
  UPDATE_CALCULATED_TIPS_RESULTS = '@@tipcalculator/UPDATE_CALCULATED_TIPS_RESULTS',
  SET_CALCULATOR_PAYEES = '@@tipcalculator/SET_CALCULATOR_PAYEES',
  SET_POS_RESULTS = '@@tipcalculator/SET_POS_RESULTS',

  LINK_EMPLOYEE_REQUEST = '@@tipcalculator/LINK_EMPLOYEE_REQUEST',
  LINK_EMPLOYEE_SUCCESS = '@@tipcalculator/LINK_EMPLOYEE_SUCCESS',
  LINK_EMPLOYEE_FAIL = '@@tipcalculator/LINK_EMPLOYEE_FAIL',

  UNLINK_EMPLOYEE_REQUEST = '@@tipcalculator/UNLINK_EMPLOYEE_REQUEST',
  UNLINK_EMPLOYEE_SUCCESS = '@@tipcalculator/UNLINK_EMPLOYEE_SUCCESS',
  UNLINK_EMPLOYEE_FAIL = '@@tipcalculator/UNLINK_EMPLOYEE_FAIL',

  GET_MATCH_EMPLOYEES_REQUEST = '@@tipcalculator/GET_MATCH_EMPLOYEES_REQUEST',
  GET_MATCH_EMPLOYEES_SUCCESS = '@@tipcalculator/GET_MATCH_EMPLOYEES_SUCCESS',
  GET_MATCH_EMPLOYEES_FAIL = '@@tipcalculator/GET_MATCH_EMPLOYEES_FAIL',

  EXPORT_CALCULATOR_SETTINGS_REQUEST = '@@tipcalculator/EXPORT_CALCULATOR_SETTINGS_REQUEST',
  EXPORT_CALCULATOR_SETTINGS_SUCCESS = '@@tipcalculator/EXPORT_CALCULATOR_SETTINGS_SUCCESS',
  EXPORT_CALCULATOR_SETTINGS_FAIL = '@@tipcalculator/EXPORT_CALCULATOR_SETTINGS_FAIL',

  IMPORT_CALCULATOR_SETTINGS_REQUEST = '@@tipcalculator/IMPORT_CALCULATOR_SETTINGS_REQUEST',
  IMPORT_CALCULATOR_SETTINGS_SUCCESS = '@@tipcalculator/IMPORT_CALCULATOR_SETTINGS_SUCCESS',
  IMPORT_CALCULATOR_SETTINGS_FAIL = '@@tipcalculator/IMPORT_CALCULATOR_SETTINGS_FAIL',

  SET_CHANGE_LOG_ENTRIES = '@@tipcalculator/SET_CHANGE_LOG_ENTRIES',
}
